// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"753efa8a213ba273e161","293":"ca40bb2309d182015ca7","518":"87435b41f5c64b934a49","779":"16232bdaac18cfccbafd"}[chunkId] + ".js";
};